module.exports = __webpack_public_path__ + "static/rcc-os-chart-mobile-84ecf9b29b63d6d2f6a0c8475ab4a1f4.png";